import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MenuBarService } from '@app/layouts/services/menu-bar.service';

import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-header-post',
  imports: [SHARED_MODULES],
  templateUrl: './header-post.component.html',
  host: { class: 'flex gap-2 py-5 items-baseline px-7' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderPostComponent {
  private readonly _menuBarService = inject(MenuBarService);

  public onOpenFilter() {
    this._menuBarService.openFilter();
  }
}
